export const tr = {
  eventDate: {
    ended: "Etkinlik sona erdi.",
    register:"Kayıt gerçekleştirdiniz mi?",
    start: "Etkinlik {0} başlıyor."
  },
  wait: "Lütfen Bekleyin",
  filter: "Seçiniz...",
  search: "Arama...",
  refresh: "Yenile",
  close: "Kapat",
  add: "Ekle",
  choose: "Seçiniz...",
  emailRequiredFastLogin: "Lütfen bir e-posta adresi girin.",
  passwordRequiredFastLogin: "Lütfen hesap şifrenizi girin.",
  contentNotFound: "Henüz hiç içerik yayınlanmamış.",
  contentFilterNotFound: "Arama veya filtre kriterine uygun içerik bulunmuyor.",
  welcome: "Hoşgeldin",
  legal: "Yasal",
  app: "Uygulama",
  recommendFriend: "Arkadaşına öner",
  sendFeedback: "Geri bildirim gönder",
  rateUs: "Bizi değerlendirin",
  aboutApp: "Uygulama Hakkında",
  showMore: "Daha fazla göster",
  header: {
    welcome: "Hoşgeldin, <strong>{name}</strong>",
    myaccount: "Profilim",
    profilesettings: "Profil Ayarları",
    accountsettings: "Hesap Ayarları",
    logout: "Çıkış Yap",
    passwordsettings: "Şifre Ayarları",
    contacts: "Kişilerim"
  },
  policies: {
    kvkk: "K.V.K.K Aydınlatma Metni",
    privacyPolicy: "Gizlilik İlkeleri",
    termsOfUse: "Kullanım Koşulları",
    cookiePolicies: "Çerezlerin Kullanımı"
  },
  account_bar: {
    fullscreen: "Tam Ekran",
    normal_screen: "Normal Ekran",
    messages: "Mesajlar",
    my_account: "Hesabım",
    notifications: "Bildirimler",
    side_bar_open: "Yan menü Aç/Kapat"
  },
  meetControls: {
    toggleCam: "Kamerayı aç/kapat",
    toggleMic: "Mikrofonu aç/kapat",
    toggleSocialHub: "Sosyal hub aç/kapat",
    inviteSomeone: "Davet et",
    openSettings: "Ayarları aç",
    sharePresentation: "Sunum paylaş",
    shareVideo: "Ekran paylaş",
    leaveRoom: "Odadan çık",
    leaveRoomSureMsg: "Odadan ayrılmak istediğinize emin misiniz?",
    confirmLeave: "Evet, ayrıl",
    cancelLeave: "Hayır, odada kal",
    settings: "Ayarlar",
  },
  inviteToRoom: "Odaya davet et",
  account_settings: {
    settings: "Ayarlar",
    profile: {
      title: "Profil",
      settings: "Profil ayarları",
      visibleDesc: "Profiliniz görüntülenebilir durumda. Bu kısımda paylaştığınız bilgiler diğer kişiler tarafından arama ve eşleşmelerde görüntülenebilir.",
      visible: "Görüntülenebilir",
      invisibleDesc: "Profiliniz görüntülenemez durumda. Bu kısımda paylaştığınız bilgiler diğer kişiler tarafından arama ve eşleşmelerde görüntülenemez.",
      invisible: "Görüntülenemez",
      show_busy: "Beni meşgul göster",
      my_linked_account: "Bağlı hesaplarımı göster",
      email: "E-Posta"
    },
    account: {
      title: "Hesap",
      description: "Hesabınız güvenli. Hesap bilgilerinizi {date} tarihinde güncellemişsiniz. Bir değişiklik yaptıysanız güncellemenizi rica ederiz.",
      language: "Dil",
      tr: "Türkçe",
      en: "İngilizce",
      account_transactions: "Hesap İşlemleri",
      delete_account: "Hesabımı sil"
    },
    password: {
      title: "Şifre",
      password_transactions:"Şifre İşlemleri",
      description: "Şifrenizi en son {date} tarihinde güncellediniz. Hesap güvenliğiniz için şifrenizi maksimum 6 ayda bir kez değiştiriniz.",
      never_updated_password: "Şifrenizi {date} tarihinde oluşturdunuz ve hiç güncellemediniz. Hesap güvenliğiniz için şifrenizi maksimum 6 ayda bir kez değiştiriniz."
    }
  },

  contacts_hub: {
    title: "Bağlantılarım",
    menu: {
      messages: {
        title: "Mesajlar",
        select_message: "Mesajları görüntülemek için soldan bir sohbet seçin."
      },
      contacts: {
        title: "Bağlantılarım"
      },
      suggestions: {
        title: "Öneriler"
      }
    }
  },
  swallFireNotify: {
    warning: "Uyarı",
    content: "Lütfen bu soruya yanıt verin"
  },
  socialfeed: {
    title: "Kısıtlı erişim",
    desc: "Sosyal akışı görebilmeniz için bu etkinliğin katılımcısı olmanız gerekir."
  },
  program: {
    title: "Program",
    menu: {
      details: "Ayrıntılar",
      reviews: "İncelemeler",
      attendees: "Katılımcılar",
      appreciations: "Değerlendirmeler",
      alreadyRate: "Bu oturumu değerlendirdiniz.",
      speakers: "Konuşmacılar",
      closedRegister: "Kayıtlar kapalıdır.",
      participants: "Katılımcılar"
    }
  },
  countdown: {
    days: "Gün",
    hours: "Saat",
    minutes: "Dakika",
    seconds: "Saniye"
  },
  camera_settings: {
    title: "Yayına hazırlanın",
    camera: "Kamera",
    no_camera: "Kamera bulunamadı",
    microphone: "Mikrofon",
    no_microphone: "Mikrofon bulunamadı",
    speaker: "Hoparlör",
    no_speaker: "Hoparlör bulunamadı",
    auto_open: "Otomatik aç",
    refresh_screen: "Ekranı yenile",
    chrome_info: "Chrome tarayıcıda nasıl yapıldığını öğrenin",
    safari_info: "Safari tarayıcıda nasıl yapıldığını öğrenin",
    okey: "Her şey tamam!"
  },
  deviceConnectionErrors: {
    notFound: "Bilgisayara bağlı hiç kamera ya da mikrofon bulunamadı.",
    noCameraFound: "Bağlı hiç kameranız yok. Lütfen kamera bağlantınızı kontrol edin.",
    noMicFound: "Bağlı hiç mikrofonunuz yok. Lütfen mikrofon bağlantınızı kontrol edin",
    noOutputDevice: "Bağlı ses çıkış cihazı yok. Lütfen bir hoparlör ya da kulaklık takın.",
    notReadable: "Kamera ya da mikrofonunuz başka bir uygulama tarafından kullanılıyor.",
    notAllowed: "Lütfen tarayıcınızın kamera ve mikrofon erişim izinlerini verin.",
    openPermissions: "Tarayıcınızın adres çubuğundaki 'Güvenli' yazısına tıklayarak açılan kısımdan izinleri açabilirsiniz.",
    unexpectedProblem: "Kamera ve mikrofonunuza erişirken beklenmedik bir sorun yaşıyoruz.",
  },
  speaker: {
    title: "Konuşmacı Profili",
    sessions_speaker: "Konuşmacı olduğu programlar",
    speaker_camera_off: "Konuşmacı Kamerası Kapalı",
    speaker_microphone_off: "Konuşmacı Mikrofonu Kapalı"
  },
  speakerSteps: {
    tour1: "Mikrofon ve kameranızı bu butonları kullanarak açıp, kapatabilirsiniz. Ekran paylaşımı için sağdaki butonu kullanabilirsiniz.",
    tour2: "Sunum paylaşmak için bu butonu kullanın",
    tour3: "Video paylaşmak için bu butonu kullanın",
    tour4: "Sağdaki alanı daraltarak yer kazanabilirsin.",
    tour5: "Bu butonu kullanarak uygulamayı tam ekran kullanabilirsin.",
    tour6: "Diğer katılımcılardan gelen mesajları buradan görüntüleyebilir ve mesajlaşabilirsiniz.",
    tour7: "Etkinlik ile ilgili tüm duyuru, bilgilendirme ve gelişmelere buradaki bildirimler kısmında erişebilirsiniz.",
    invite_step: "Bu butona tıklayarak diğer katılımcıları networking masana davet edebilir,  görüntülü ve sesli görüşme gerçekleştirebilirsin."
  },
  homeTourSteps: {
    tour1: "Canlı oturumlara buradan hızlıca erişebilirsiniz.",
    tour2: "Burası, etkinliğe ait tüm detaylara erişebildiğiniz Resepsiyon alanıdır.",
    tour3: "Tüm canlı yayın oturumlarına buradan erişebilirsiniz.  Konuşmacı olduğunuz oturumlar var ise ayrıca görebilirsiniz.",
    tour4: "Etkinliğe katılan diğer katılımcılar ile bu alandaki masalarda sesli ve görüntülü görüşmeler gerçekleştirebilir ve sunum yapabilirsiniz.",
    tour5: "Etkinlikte yer alan sanal stantları ziyaret edebilir, stantlarda gerçekleştirilen aktivitelere katılabilirsiniz."
  },
  tourButton: {
    buttonSkip: "Tanıtımı Geç",
    buttonPrevious: "Önceki",
    buttonNext: "Sonraki",
    buttonStop: "Bitir"
  },

  appointment: {
    title: "Randevu Oluştur",
    appointments: "Randevular",
    expired_date: "Etkinlik tarihi sona ermiş, randevu oluşturulamaz.",
    cannot_select: "Etkinlik seçemezsiniz.",
    cannot_add_participant: "Katılımcı ekleyemezsiniz.",
    appointment_time_full: "Randevu saati dolu",
    appointment_times: "Randevu Saatleri",
    must_choose_date: "Tarih seçmelisiniz",
    event_name: "Etkinlik Adı",
    appointment_subject: "Randevu Konusu",
    appointment_date: "Randevu Tarihi",
    appointment_hour: "Randevu Saati",
    appointment_duration: "Randevu Süresi",
    appointment_venue: "Randevu Yeri",
    first_of_all_pick_event: "Öncelikle randevu seçiniz",
    people: "Kişiler",
    create: "Oluştur",
    empty_appointment_list: "Randevunuz Yok",
    pending: "Cevap Bekliyor",
    coming: "Yaklaşan Randevular",
    past: "Geçmiş ve Reddedilen",
    collapse: "Daralt",
    see_profile: "Profili Gör",
    remove: "Sil",
    approve: "Onayla",
    reject: "Reddet",
    join_only_you: "Sadece siz katılıyorsunuz.",
    you_and_value: "Siz ve {0} kişi katılıyor",
    pending_person: "Bekleniyor",
    join_person: "Katılacak",
    reject_person: "Katılmayacak",
    notifications: "Bildirimler",
    appointments: "Randevular",
    no_pending: "Beklenen randevunuz bulunmamaktadır.",
    no_coming: "Yaklaşan randevunuz bulunmamaktadır.",
    no_past: "Geçmiş randevunuz bulunmamaktadır.",
    no_notifications: "Bildiriminiz Yok",
    search_person: "Kişi Ara...",
    close_dialog: "Kapat",
    save: "Kaydet",
    b2b: "İkili görüşme",
  },
  login: {
    completeRegister: "Kaydı tamamla",
    title: "Live Event Experience",
    description: "İnteraktif ve keyifli bir etkinlik deneyimi için şimdi  hesabınızı oluşturun.",
    email: {
      title: "E-Posta adresi"
    },
    password: {
      title: "Şifre"
    },
    forgot_password: "Şifrenizi mi unuttunuz?",
    login: "Giriş yap",
    back: "Geri Dön",
    facebook: "Facebook ile giriş",
    activationCode: "Aktivasyon kodu",
    fastLogin: "Aktivasyon kodu",
    fastLoginBtn: "Giriş yap",
    withemailpass: "E-Posta ve Şifre",
    useactiveemail: "Aktif olarak kullandığınız e-posta adresinizi yazınız.",
    activationinfo: "E-posta ya da SMS yolu ile tarafınıza ulaştırılan voucher içerisinde bulunan 13 haneli aktivasyon kodunuzu buraya girerek etkinliğe erişebilirsiniz.",
    usesocialacc: "Sosyal medya hesabıyla giriş yap",
    desc: "Sizi tekrar aramızda görmek harika!",
    desc2: "Hesabınıza bağlı tüm etkinliklere erişmek için, giriş yapın.",
    downloadapp: "Uygulamayı indir",
    welcome: "Hoş Geldiniz!"
  },
  register: {
    title: "Live Event Experience",
    description: "Bugüne kadar katıldığınız tüm etkinlikleri görebilir, sanal etkinlikleri size gönderilmiş olan aktivasyon kodlarıyla aktifleştirerek katılım sağlayabilirsiniz.",
    email: "E-Posta adresi",
    password: "Şifre",
    passwordRetry: "Şifre (Tekrar)",
    forgot_password: "Şifrenizi mi unuttunuz?",
    firstName: "Ad",
    lastName: "Soyad",
    backButton: "Siteye Dön",
    register: "Hesap oluştur",
    desc: "Katıldığınız tüm etkinlikleri tek bir hesaba bağlayabilirsiniz."
  },
  forgot: {
    title: "Live Event Experience",
    description: "Bugüne kadar katıldığınız tüm etkinlikleri görebilir, sanal etkinlikleri size gönderilmiş olan aktivasyon kodlarıyla aktifleştirerek katılım sağlayabilirsiniz.",
    email: "E-Posta Adresi",
    password: "Şifre",
    passwordRetry: "Şifre (Tekrar)",
    forgot_password: "Şifremi Unuttum",
    resetToken: "Sıfırlama Kodu",
    lastName: "Soyad",
    forgot: "Şifremi sıfırla",
    resend: "Tekrar Gönder",
    desc: "Hesap güvenliğiniz için yeni şifrenizi rakam, harf ve özel karakter kullanarak oluşturabilirsiniz."
  },
  event: {
    where_when: "<strong>{when}</strong> tarihinde <strong>{where}</strong> mekanında gerçekleşecek.",
    where_not_when: "<strong>{when}</strong> tarihinde gerçekleşecek.",
    menu: {
      goback: "Geri dön",
      about: "Hakkında",
      speakers: "Konuşmacılar",
      program: "Program",
      sponsors: "Sponsorlar",
      questions: "Sık Sorulan Sorular",
      documents: "Dokümanlar",
      surveys: "Anketler",
      gallery: "Fotoğraf Albümü",
      ask: "Konuşmacıya Sor",
      poll: "Canlı Oylama",
      social: "Sosyal Hub",
      participants: "Katılımcılar"
    },
    headerinfo: {
      title: "Aktivasyon gerekli",
      activation1: " Aktivasyon kodunu kullanmak için ",
      activation2: "tıklayın.",
      activation3: "",
      ticket1: "Etkinliğe kayıt olmak veya bilet satın almak için ",
      ticket2: "tıklayın.",
      ticket3: "",
      contact1: "Online kayıtlar kapalıdır. Organizator ile iletişime geçmek için ",
      contact2: "tıklayın.",
      contact3: ""
    },
    speakers: {
      title: "Konuşmacılar",
      description: "Etkinlik konuşmacılarını buradan görebilirsiniz.",
      refresh: "Yenile"
    },
    program: {
      title: "Etkinlik Programı",
      description: "Etkinlik Programını buradan görebilirsiniz.",
      refresh: "Yenile",
      reset: "Filtreyi Sıfırla",
      filter_title: "Sonuç Bulunamadı",
      filter_today_title: "Bugüne Ait Program Yok",
      all_saloons: "Tüm Mekanlar",
      search_placeholder: "Program & Konuşmacı Ara",
      subevent_filter: "{title} alt etkinliğine ait programları görüntülüyorsunuz",
      sub_event_register: "Alt etkinliğe kayıt ol"
    },
    sponsor: {
      title: "Sponsorlar",
      description: "Sponsorları buradan görebilirsiniz.",
      refresh: "Yenile"
    },
    question: {
      title: "Sık Sorulan Sorular",
      description: "Soru kütüphanesini buradan görebilirsiniz.",
      refresh: "Yenile"
    },
    document: {
      title: "Dokümanlar",
      description: "Dokümanları buradan görebilirsiniz.",
      refresh: "Yenile",
      reset: "Filtreyi Sıfırla",
      filter_title: "Sonuç Bulunamadı",
      search_placeholder: "Dokümanlar içerisinde ara",
      all: "Tümü",
      reset2: "Sıfırla"
    },

    survey: {
      title: "Anketler",
      description: "Anketleri buradan görebilirsiniz.",
      refresh: "Yenile",
      completed: "Bu ankete katıldınız.",
      answer: "Yanıtınızı Buraya Yazın",
      complete: "Anketi Tamamla",
      next: "İleri",
      placeholder: "Yanıtınızı Buraya Yazın"
    },
    gallery: {
      title: "Fotoğraf Albümü",
      description: "Fotoğraf albümünü buradan görebilirsiniz.",
      refresh: "Yenile"
    },
    poll: {
      description: "Canlı oylama açıldığında otomatik olarak burada görüntülenecektir."
    }
  },
  sessions: {
    join: "KATIL",
    watcherCount: "({watcherCount})",
    live: "CANLI",
    waiting: "BEKLİYOR",
    info_title: "Canlı Oturumlar",
    info_description: "Bu alanda etkinliğe ait tüm canlı yayın oturumları yer almaktadır. Etkinliğe kayıt durumunuz ve bağlı olduğunuz katılımcı türüne göre oturumlara katılabilir ve izleyebilirsiniz.",
    speaker: {
      title: "Konuşmacı Olduğunuz Oturumlar",
      description: "Konuşmacı olduğunuz oturumları görüntülüyorsunuz.<br>Canlı yayın öncesinde bu oturumlara girip diğer konuşmacılar ile ön hazırlık yapabilirsiniz."
    },
    participant: {
      title: "Katılımcı Olduğunuz Oturumlar",
      description: "Katılımcı olduğunuz oturumları görüntülüyorsunuz.<br>Daha önce kayıt yaptırmış olduğunuz oturumları buradan görüntüleyebilir, oturum saati geldiğinde katılabilirsiniz."
    }
  },
  askspeaker: {
    nomore: "Daha fazla soru yok",
    nodata: "Henüz hiç soru sorulmamış",
    share: "Bir soru sor"
  },
  downloadapp: {
    title: "Uygulamayı İndirin",
    description: "Bu özelliği ve diğer bir çok özelliği kullanabilmek için uygulamamızı indirin."
  },
  settings: {
    addnew: "Yeni",
    general_title: "Genel Ayarlar",
    email: "E-Posta",
    add_new: "Ekle",
    cellPhone: "Cep Telefonu",
    about: "Hakkımda",
    save: "Kaydet",
    job_title: "İş",
    new: "Yeni",
    jobs_description: "Buradaki bilgiler profilinizde herkese açık olarak görüntülenecektir.",
    firmName: "Firma Adı",
    position: "Pozisyon",
    dateStart: "Başlangıç Tarihi",
    dateEnd: "Bitiş Tarihi",
    dateEndPlaceholder: "Bitiş tarihi (Devam ediyorsanız boş bırakın)",
    date_format: "GG/AA/YYYY",
    no_end: "Devam Ediyor",
    edit: "Düzenle",
    remove: "Sil",
    school_title: "Eğitim",
    school_description: "Buradaki bilgiler profilinizde herkese açık olarak görüntülenecektir.",
    title: "Başlık",
    department: "Bölüm",
    interest_title: "İlgi Alanları",
    interest_description: "Buradaki bilgiler profilinizde herkese açık olarak görüntülenecektir.",
    search_interest: "İlgi alanları içerisinde arayın...",
    close: "Kapat",
    country: "Ülke",
    country_error: "Geçerli bir telefon numarası girin",
    phone: "Telefon numarası",
    example: "Örnek :",
    school: "Okul"
  },

  password: {
    currentPassword: "Mevcut şifreniz",
    newPassword: "Yeni şifreniz",
    newPasswordRetry: "Yeni şifreniz (tekrar)",
    passwordChangeAttention: "Güvenliğiniz için şifrenizi 6 ayda bir güncellemenizi öneriyoruz.",
    passwordLastChange: "Şifrenizi en son güncellediğiniz tarih: ",
    passwordNotChanged: "Şifrenizi daha önce hiç güncellemediniz."
  },
  save: "Kaydet",
  change_image: "Fotoğrafı Değiştir",
  home: {
    joined_description: "Bu güne kadar katıldığınız tüm etkinlikler.<br /> Voucher ile gelen kodu aktifleştirerek etkinliklerinize erişebilirsiniz.",
    joined_title: "Katıldığınız Etkinlikler",
    join: "Etkinlik Aktifleştir",
    date_format: "<strong>{date}</strong> tarihinde <strong>{venue}</strong> mekanında gerçekleşecek",
    activate: "Etkinlik Aktifleştir",
    activateInfo1: "E-posta ya da SMS yolu ile tarafınıza ulaştırılan voucher içerisinde bulunan 13 haneli aktivasyon kodunuzu buraya girerek etkinliği hesabınızda aktifleştirebilirisiniz.",
    activateInfo2: "Bu işlem tek seferlik olup tekrardan aktif etmenize gerek yoktur.",
    activateInfo3: "Tarafınıza aktivasyon kodu ulaşmadı ise organizatör firma ile iletişime geçebilirsiniz."
  },
  do_activate: "Aktifleştir",
  pending: "Onay Bekliyor",
  rejected: "Reddedildi",
  microphone_info: "Bu kısımdan mikrofonunuzu ve kameranızı dilediğiniz zaman açıp kapatabilir veya ekran paylaşımı başlatabilirsin",
  networking: {
    title: "Networking Alanı",
    description: "Networking odalarında diğer katılımcılar ile canlı görüşmeler gerçekleştirebilirsiniz.Her masanın doluluk durumlarını ve katılımcılarını görüntüleyebilir ve müsait odalara katılabilirsiniz",
    lock_open: "Açık",
    lock_closed: "Dolu"
  },
  stands: {
    title: "Fuaye Alanı",
    all: "Tümü",
    description: "Fuaye alanları ve stantların yer aldığı bu bölümde fuaye alanlarını gezebilir, stant sayfalarını ziyaret edebilir ve stant temsilcileri ile görüşmeler gerçekleştirebilirsiniz"
  },
  close: "Kapat",
  vote: {
    dovote: "OYLA"
  },
  leftmenu: {
    reception: "Resepsiyon",
    sessions: "Oturumlar",
    networking: "Networking",
    stands: "Fuaye"
  },
  poll: {
    select_answer: "Lütfen cevabınızı belirtin."
  },
  tabBar: {
    events_attended: "Katıldığım Etkinlikler",
    upcoming_events: "Yaklaşan Etkinlikler",
    past_events: "Geçmiş Etkinlikler"
  },
  recursiveQuestionBuilder: {
    dragClick: "Yüklemek için sürükle veya <em>tıkla.</em>",
    dragMsg: "maksimum dosya boyutunuz"
  },
  checking_in: "Check-in yapılıyor",
  check_in: "Check-in yap",
  checked_in: "Check-in yapıldı",
  noroom: "Şuan görüşme alanlarında yer yok. Lütfen daha sonra tekrar deneyin.",
  write_rate_here: "Değerlendirmenizi buraya yazın...",
  your_rate: "Değerlendirmeniz",
  send: "Gönder",
  phone_not_confirmed: "Telefon numarası doğrulanmadı.",
  email_not_confirmed: "E-Posta adresi doğrulanmadı.",
  confirm_now: "Şimdi Doğrula",
  write_key: "Kodu Girin",
  confirm: "Doğrula",
  email_confirmed: "E-Posta adresinizi doğruladınız.",
  phone_confirmed: "Telefon numaranızı doğruladınız.",
  write_message: "Bir mesaj yaz...",
  send_network_req: "Görüşme Talebi Gönder",
  network_request_received: "{name} size görüşme talebi gönderdi",
  network_req_message: "Görüntülü görüşme isteği gönderildi",
  accept: "Kabul Et",
  reject: "Reddet",
  showNotifications: "Bildirimleri gör",
  job: "İş",
  school: "Okul",
  register_limit: "Katılım {stock} kişi ile sınırlıdır.",
  subevent_confirmed: "Katılım Talebiniz Onaylandı",
  subevent_pending: "Katılım Talebiniz Onay Bekliyor",
  image_uploaded: "Fotoğraf Yüklendi",
  share: "Bir şeyler paylaş",
  message_sent: "Mesaj Gönderildi.",
  nochat: "Hiç mesaj yok.",
  nomobilesupport: "Bu uygulamanın mobil uyumluluk desteği şimdilik bulunmuyor.",
  add_calendar: "Takvimine Ekle",
  rate_program: "Programı Değerlendir",
  program_rated: "Programı Değerlendirdiniz",
  search_contacts: "Kişilerim içerisinde ara...",
  search_suggestion: "Önerilenler içerisinde ara....",
  contacts: "Kişilerim",
  contacts_no_data: "Kişilerinizi buradan görebilirsiniz",
  contacts_remove: "Bu kişiyi listenizden çıkarmak istediğinize emin misiniz?",
  announcement: "Duyuru",
  announcements: "Duyurular",
  share_a_post: "Bir gönderi paylaş",
  nomorepost: "Daha fazla gönderi yok.",
  nopost: "Henüz hiç gönderi paylaşılmamış.",
  delete: "Sil",
  notifications: {
    menu: {
      notifications: "Bildirimler",
      appointments: "Randevular"
    },
    events: {
      delete: "Sil",
      mark_as_read: "Okundu işaretle",
      delete_all: "Tümünü sil",
      mark_all: "Tümünü okundu işaretle"
    },
    no_notifications: "Hiç bildirim yok"
  },

  nodatakeys: {
    speakers: {
      nodatatitle: "Konuşmacılar",
      nodatadesc: "Etkinlik konuşmacıları yayınlanmamış.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Konuşmacılar",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle"
    },
    program: {
      nodatatitle: "Program",
      nodatadesc: "Program akışı ve oturumlar yayınlanmamış.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Program",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle",
      daydatatitle: "Program",
      daydatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      daydatabutton: "Yenile"
    },
    sponsors: {
      nodatatitle: "Sponsorlar",
      nodatadesc: "Etkinlik sponsorları yayınlanmamış.",
      nodatabutton: "Yenile"
    },
    attendees: {
      nodatatitle: "Katılımcılar",
      nodatadesc: "Etkinlikte aktivasyon yapmış katılımcı bulunmamaktadır.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Katılımcılar",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle",
      noaccesstitle: "Katılımcılar",
      noaccessdesc: "Bu etkinlikte katılımcıların etkileşimi kısıtlanmıştır.",
      noaccessbutton: "Geri dön"
    },
    sessions: {
      nodatatitle: "Canlı oturumlar",
      nodatadesc: "Aktif bir canlı oturum bulunmamaktadır.",
      nodatabutton: "Yenile"
    },
    networking: {
      nodatatitle: "Networking alanı",
      nodatadesc: "Aktif bir networking alanı bulunmamaktadır.",
      nodatabutton: "Yenile"
    },
    gallery: {
      nodatatitle: "Fotoğraf albümü",
      nodatadesc: "Henüz hiç fotoğraf paylaşılmamış.",
      nodatabutton: "Yenile"
    },
    surveys: {
      nodatatitle: "Anketler",
      nodatadesc: "Katılabileceğiniz bir anket yayınlanmamış.",
      nodatabutton: "Yenile"
    },
    maps: {
      nodatatitle: "Alan haritaları",
      nodatadesc: "Alan haritaları yayınlanmamış.",
      nodatabutton: "Yenile"
    },
    faq: {
      nodatatitle: "Sık sorulan sorular",
      nodatadesc: "Herhangi bir konuda içerik yayınlanmamış.",
      nodatabutton: "Yenile"
    },
    documents: {
      nodatatitle: "Dokümanlar",
      nodatadesc: "Henüz hiç doküman paylaşılmamış.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Dokümanlar",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle"
    },
    expo: {
      nodatatitle: "Fuaye",
      nodatadesc: "Fuaye alanında stant bulunmamaktadır.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Fuaye",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle"
    },

    asktospeakers: {
      nodatatitle: "Konuşmacıya sor",
      nodatadesc: "Henüz bir konu yayınlanmamış.",
      nofilterdatatitle: "Konuşmacıya sor",
      nofilterdatadesc: "Henüz bir soru paylaşılmamış."
    },
    polls: {
      nodatatitle: "Canlı oylama",
      nodatadesc: "Oylama başladığında burada görüntüleyebilirsiniz."
    },
    subeventattendees: {
      nodatatitle: "Alt etkinlik katılımcıları",
      nodatadesc: "Bu alt etkinliğe katılan diğer katılımcıları bu alanda görebilirsiniz.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Alt etkinlik katılımcıları",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle"
    },
    programreviews: {
      nodatatitle: "Oturum değerlendirmeleri",
      nodatadesc: "Katılımcılar bu oturum için henüz değerlendirme yapmamış."
    },
    messagehub: {
      nodatatitle: "Hiç mesajınız yok",
      nodatadesc: "Katıldığınız etkinliklerdeki diğer katılımcılar ile mesajlaşabilirsiniz.",
      nodatabutton: "Yenile"
    },
    contacts: {
      nodatatitle: "Kişi listeniz boş",
      nodatadesc: "Etkinliklerde diğer katılımcıları ağınıza ekleyebilirsiniz.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Bağlantılarım",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle"
    },
    suggestions: {
      nodatatitle: "Öneri listeniz boş",
      nodatadesc: "Size uygun kişi önerisi bulunamadı. Daha fazla etkinliğe katılarak ve etkileşimde bulunarak ağınızı genişletebilirsiniz.",
      nodatabutton: "Yenile",
      nofilterdatatitle: "Önerilerim",
      nofilterdatadesc: "Kriterlerinize uygun sonuç bulunamadı.",
      nofilterdatabutton: "Filtreyi temizle"
    },
    notifications: {
      nodatatitle: "Bildirimler",
      nodatadesc: "Henüz bir bildirim almamışsınız.",
      nodatabutton: "Yenile"
    },
    homeactivatedevents: {
      nodatatitle: "Katıldığım etkinlikler",
      nodatadesc: "Henüz herhangi bir etkinliğe katılmamışsınız.",
      nodatabutton: "Yenile"
    },
    homeupcomingevents: {
      nodatatitle: "Yaklaşan etkinlikler",
      nodatadesc: "Yakınlarda gerçekleşecek bir etkinlik bulunmuyor.",
      nodatabutton: "Yenile"
    },
    homepastevents: {
      nodatatitle: "Geçmiş etkinlikler",
      nodatadesc: "Geçmiş zamanda bir etkinlik bulunmuyor.",
      nodatabutton: "Yenile"
    }
  },
  socialValid: {
    minLength: "En az {0} karakter girmelisiniz",
    email: "Lütfen doğru formatta bir e-posta giriniz.",
    nullCheck: "Lütfen soruyu cevaplayın.",
    nullCheck2: "Lütfen en az bir cevap seçiniz."
  },
  no_data_text: "Veri bulunamadı.",
  no_match_text: "Eşleşen veri yok",
  filterGroupPlaceholder: "Katılımcı grubuna göre filtrele",
  block_user: "Kullanıcıyı engelle",
  load_more: "Daha fazla gör",
  notify_warning: "Uyarı",
  notify_confirm: "Evet",
  notify_cancel: "Vazgeç",
  volume_on_off: "Sesi Aç/Kapat",
  invite_room: "Davet Et",
  invite: "DAVET GÖNDER",
  search_in: "Katılımcılar içerisinde ara...",
  tag_filter: "Etiket Filtresi",
  view_profile: "Profili Gör",
  clear_messages: "Konuşmayı Temizle",
  delete_chat: "Konuşmayı Sil",
  fill_blank_input: "Lütfen boşlukları doldurunuz.",
  no_more_message: "daha fazla mesaj yok",
  no_message: "Henüz hiç mesaj yok",
  permission_error: "Kameranıza erişilirken bir hata oluştur. Kamera izinlerinizi tam olarak verdiğinizden ve kameranızın başka bir uygulama tarafından kullanılmadığından emin olun. Hata mesajı:",
  camera_error: "Kamera & Mikrofon Hatası",
  permission_help: "Yardım için buraya tıklayın",
  stand_about: "Hakkında",
  stand_authorities: "Yetkililer",
  search_in_speaker: "Konuşmacılar içerisinde ara...",
  sub_event_filter: "Alt Etkinlik Filtresi",
  make_appointments: "Randevu Oluştur",
  back_surveys: "Anketlere Dön",
  complete_survey: "Anketi Tamamla",
  next: "İleri",
  other_programs: "{program} alt etkinliğine bağlı diğer programlar",
  gallery: "Galeri",
  stand_surveys: "Anketler",
  sharing_now: "Şu anda ekran paylaşıyorsunuz.",
  odadolu: "Bu oda dolu olduğu için davet gönderilemiyor.",
  notfound: "Beğenmeye çalıştığınız gönderi silinmiştir.",
  screen_permission_error: "Ekran paylaşımı için sistem iznine ihtiyaç var. Nasıl yapıldığını öğrenmek için aşağıdaki linke tıklayın.",
  permission_help_mac: "MacOS için buraya tıklayın",
  virtualtour: "Sanal Tur",
  comment: "Yorum",
  response: "Yanıt",
  reply: "Yanıtla",
  commenting: "Kişisinin yorumuna yanıt olarak yazılıyor.",
  searchStand: "Standların içinde ara...",
  add_calendar: "Takvime ekle",
  register_and_buy_ticket: "Kayıt ol / Bilet al",
  contact_us: "İletişime geç",
  add_google_calendar: "Google takvime ekle",
  add_outlook_calendar: "Outlook takvime ekle",
  add_microsoft_calendar: "Microsoft takvime ekle",
  watch_broadcast: "Yayını izlemek için tıklayın...",
  pleaseCheckPolicy: "Lütfen kullanıcı sözleşmelerini onaylayın.",
  pleaseControlArea: "Lütfen bu alanı işaretleyin.",
  sendInvite: "Davet gönder",
  accountSettings: {
    settings: "Ayarlar",
    information: "Bilgiler",
    company: "Şirket",
    title: "Ünvan",
    work: "İş",
    language: "Dil",
    speaking: "Konuşma -",
    writing: "Yazma -",
    reading: "Okuma -",
    account: "Hesap",
    notifications: "Bildirimler",
    eventNotifications: "Etkinlik bildirimleri",
    contactNotifications: "Kişi bildirimleri",
    messageNotifications: "Mesaj bildirimleri",
    addJob: "Yeni iş ekle",
    addTutorial: "Yeni eğitim ekle",
    addLanguage: "Yeni dil ekle",
    deleteAccount: "Hesabı sil"
  },
  addLanguage: {
    language: "Dil",
    speaking: "Konuşma",
    writing: "Yazma",
    reading: "Okuma"
  },
  directions: "Yol Tarifi",
  biography: "Biyografi",
  programs: "Programlar",
  uploads: "Yüklenenler",
  eventMemories: "Etkinlik Anıları",
  chooseEvent: "Etkinlik Seçiniz...",
  loginText: "Giriş Yap",
  guestText: "Misafir",
  registerText: "Hesap Oluştur",
  loginFirst: "Bu işlemi gerçekleştirebilmeniz için giriş yapmanız gerekmektedir.",
  pleaseChooseOneAttendee: "Lütfen en az bir katılımcı seçiniz. Katılımcı seçmeden önce etkinlik seçmelisiniz.",
  socialhub: {
    topic: "KONU",
    comment: "yorum",
    bigComment: "yorum",
    doComment: "İlk yorumu sen yap",
    reply: "yanıtla",
    cancel: "vazgeç",
    likeYouAndMore: "Siz ve {0} kişi bunu beğendi",
    likeYou: "Siz bunu beğendiniz",
    likeMore: "{0} kişi bunu beğendi",
    like: "Beğen",
    newPost:"Yeni Gönderi",
    alreadyLike: "Beğendiniz",
    readMore: "Devamını oku",
    hide:"Gizle",
    surveyQuestionNumber: "Anket yaklaşık {0} sorudan oluşmaktadır.",
    voteEnded: "Oylama sonlanmıştır.",
    voteEnd: "Oylama sonlandı.",
    vote: "Oyla",
    voteJoinNumber: "{0} kişi oylamaya katıldı.",
    alreadyJoinSurvey: "Bu ankete katıldınız.",
    join: "Katıl",
    next: "Sonraki",
    talkingPeople: "kişi bu konu hakkında konuşuyor.",
    loadMore: "Daha fazla yükle",
    hideComments: "Yorumları gizle",
    hideReply: "Yanıtları gizle",
    deleteComment:"Yorumu sil",
    deletePost:"Gönderiyi sil",
    menu : {
      hub: "Sosyal hub",
      questionAnswer: "Soru & Cevap",
      voting: "Oylama",
      survey: "Anket"
    },

    nodatatitle: "Social hub",
    nodatadesc: "Henüz bir gönderi paylaşılmamış.",
    noaccesstitle: "Duyurular",
    noaccessdesc: "Henüz bir gönderi paylaşılmamış."
  },
  reconnect_server:"İnternet bağlantınız stabil değil, yeniden bağlanmaya çalışıyor...",
  broadcast_connect: "Yayına bağlanılıyor ",
  deleteMyAccount: "Hesabınızı neden silmek istiyorsunuz?",
  reason:"Açıklama",
  userProfile:{
    profileActive: "Kişi profili açık modda",
    profileDeactive: "Kişi profili kapalı modda",
    profileActiveText: "Profil görüntülenebilir",
    profileDeactiveText: "Profil görüntülenemez",
    profileBusy: "Kişi şu anda meşgul durumda",
    profileAvailable:"Kişi şu an müsait",
    profileAvailableText:"İletişime açık",
    add_contact: "Bağlantılarıma ekle",
    remove_contact:"Bağlantılarımdan kaldır",
    block_user: "Engelle",
    unblock_user: "Engeli kaldır",
    speaking: "Konuşma : ",
    writeRead: "Okuma / Yazma : ",
    language: "Dil",
    info: "Bilgiler",
    sameEvents: "Ortak etkinlikler",
    makeAppointment:"Randevu",
    b2b:'İkili görüşme',
    appointment_request:"Görüşme talebi"
  },
  selectTopic: "Konu seçebilirsiniz",
};



// WEBPACK FOOTER //
// ./src/language/tr.js